import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  Inject
} from '@angular/core';
import {OX_KEYS} from '@ox/config';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {
  Copy,
  ManagePlanPageInfo,
  StepperReturnState,
  StepperValue,
  Plans,
  EmitObject,
  Outs
} from '@ox/typings';
import {MyPlansUnifiedService, AssetsService} from '@webu/data';
import {ManagePlanPageSettings} from '../ManagePlanPageSettings';
import {Subject, takeUntil} from 'rxjs';
import {AutoDestroy, SessionStorageService} from '@ox/utils';
import {APP_BASE_HREF} from '@angular/common';
import {DisclosureModalComponent} from '../disclosure-modal/disclosure-modal';
import {ServiceModalComponent} from '../service-modal/service-modal';
import {TrackingService} from '@ox/data';
import {Store} from '@ngrx/store';

@Component({
  selector: 'webu-billing-cycle-toggle',
  templateUrl: './billing-cycle-toggle.component.html'
})
export class BillingCycleToggleComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() isAnnual = false;
  @Input() saveWithAnnualMessage: string;
  @Output() isAnnualChangedEvent = new EventEmitter<boolean>();
  pageSettings: ManagePlanPageInfo;
  managePlanPageSettings: ManagePlanPageSettings;
  public toggleOptions = ['Monthly', 'Yearly'];
  isUpdatePlanComponent = true;
  pageType: string;
  offers: any;
  copyData: Copy;
  copy: Copy = {};
  products: Plans[];
  bsModalRef?: BsModalRef;
  footerObj?: EmitObject;
  data: any;
  productdisclosure: any;
  productDisclosure: any;
  assestplans: any;
  imagevalue: any;
  outs: Outs;
  nth_time: any;

  public featurePopupResponse: any;

  constructor(
    private modalService: BsModalService,
    private assetsService: AssetsService,
    private sessionStorageService: SessionStorageService,
    @Inject(APP_BASE_HREF) private _baseHref: string,
    private myPlansUnifiedService: MyPlansUnifiedService,
    public trackingService: TrackingService,
    private store: Store
  ) {
    this.pageType = OX_KEYS.MY_PLANS.MANAGE_KEY;
  }
  ngOnInit(): void {
    this.data = this.sessionStorageService.getFromJson('copyData');
    this.footerObj = this.sessionStorageService.getFromJson('FooterInfo');
    const offers = [];
    if (this.footerObj && this.footerObj.product) {
      offers.push(this.footerObj.product);
    }
    if (this.footerObj.residueBYO) {
      offers.push(...this.footerObj.residueBYO);
    }
    this.offers = offers;
    this.managePlanPageSettings = new ManagePlanPageSettings(this.store);
    this.pageSettings = this.managePlanPageSettings.getPageType(this.pageType);
    this.myPlansUnifiedService.hideHeaderFooter();
    this.isAnnual = !this.footerObj.isMonthly;
  }

  setValue = (event: any, value: boolean) => {
    this.isAnnual = value;
    
    this.offers.forEach((item: Plans) => {
      const newPrice = item.offer?.prices.find(
        (price) => price.billingFrequency === (value ? 'PREPAID' : 'MONTHLY')
      );
      if (newPrice) {
        item.price = newPrice;
      }
    });

    const newFinalPrice = this.offers
      .map((item: Plans) => item.price.customerFinalPrice)
      .reduce((a: number, b: number) => a + Number(b), 0);
    if (this.footerObj && newFinalPrice) {
      this.footerObj.price = parseFloat('' + newFinalPrice).toFixed(2);
      this.footerObj.isMonthly = !value;
    }

    this.isAnnualChangedEvent.emit(value);
    event.preventDefault(); // Prevents the parent componenet from calling this event again.
  };

  getSteps(): StepperValue[] {
    const steps: StepperValue[] = [];
    this.pageSettings.flow.forEach((step) => {
      steps.push(
        this.managePlanPageSettings.getPageType(step).stepper.stepInfo
      );
    });
    return steps;
  }

  getCurrentStep(): number {
    return this.pageSettings.flow.indexOf(this.pageType);
  }

  getReturnState(): StepperReturnState {
    return this.pageSettings.stepper.returnState;
  }
  onFooterButtonClick() {
    const offerIds = this.offers.map((item: Plans) => item.price.offerId);

    this.sessionStorageService.setAsJson('ReviewId', offerIds);
    this.sessionStorageService.setAsJson('ManagePlanInfo', {
      pageType: 'MANAGE_REVIEW',
      offerId: offerIds
    });
    this.sessionStorageService.setAsJson('FooterInfo', this.footerObj);
    window.location.href = `${this._baseHref}onstar/review`;
  }

  openDisclosureModal(product?: any) {
    if (!product) return;
    this.bsModalRef = this.modalService.show(DisclosureModalComponent, {
      initialState: {product: [product]}
    });
  }
  
  openServicemainModal(index?: any, value?: any) {
      this.outs = this.offers[index];
      // import assets from assests.json and pass into service modal
      this.assetsService?.getAssets().pipe(
        takeUntil(this.destroy$))
        .subscribe({
        next: (asset) => {
          if (asset) {
            this.featurePopupResponse = asset;
            this.assestplans = asset.plans;
            this.assestplans?.forEach((ele: any) => {
              if (ele.name === this.outs.code) {
                this.imagevalue = ele.planAssets[0].assets[0].urlPath;
              }
            });

            this.bsModalRef = this.modalService.show(ServiceModalComponent, {
              initialState: {
              value: [value],
              displayPlanNameBilling: [this.outs],
              displayImageBilling: [this.imagevalue]
            }});
          }
        },
        error: (error) => {
          console.error('Error fetching assets', error);
        }
      });
    }
}